import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.index';


import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    public Totes: Totes_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public ProgrammableLogicController: ProgrammableLogicController_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
